import api from 'api/apiInstance';

import type { VulnerabilityAssessmentResponse } from '../types';

export function clientCaseVulnerabilityAssessmentsLastApi(path: string) {
  return {
    path,
    GET: () =>
      api.get<VulnerabilityAssessmentResponse>(path, {
        // Custom interceptor flag — typed in src/types/axiosSkipRedirect.d.ts.
        // 404 = FG21/1 flag off → badge/section render nothing (fail-closed).
        skipRedirect: true,
      }),
  };
}
